import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { openSnackbar } from "../dux/snackbar";
import {
  getUserFeedbackUrl,
  getSaveUserDetailsUrl,
  getUserBookingsUrl,
} from "../helpers/apiEndPoints";

// Action types for user operations
export const USER_FEEDBACK = "USER_FEEDBACK";
export const SAVE_USER_DETAILS = "SAVE_USER_DETAILS";
export const GET_USER_BOOKINGS = "GET_USER_BOOKINGS";

const user = () => (next) => (action) => {
  next(action);

  // Submit user feedback
  if (action.type === USER_FEEDBACK) {
    next(apiCallStart({ api: "userFeedback" }));
    next(
      apiAction({
        url: getUserFeedbackUrl(),
        feature: USER_FEEDBACK,
        method: "POST",
        data: {
          feedback: action.payload.feedback,
        },
      })
    );
  }

  if (action.type === `${USER_FEEDBACK} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "userFeedback" }));
    next(openSnackbar({ message: "Feedback submitted successfully" }));
  }

  if (action.type === `${USER_FEEDBACK} ${API_ERROR}`) {
    next(apiCallComplete({ api: "userFeedback" }));
    next(openSnackbar({ message: "Failed to submit feedback", type: "error" }));
  }

  // Save user details
  if (action.type === SAVE_USER_DETAILS) {
    next(apiCallStart({ api: "saveUserDetails" }));
    next(
      apiAction({
        url: getSaveUserDetailsUrl(),
        feature: SAVE_USER_DETAILS,
        method: "POST",
        data: action.payload,
      })
    );
  }

  if (action.type === `${SAVE_USER_DETAILS} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "saveUserDetails" }));
    next(openSnackbar({ message: "User details saved successfully" }));
  }

  if (action.type === `${SAVE_USER_DETAILS} ${API_ERROR}`) {
    next(apiCallComplete({ api: "saveUserDetails" }));
    next(
      openSnackbar({ message: "Failed to save user details", type: "error" })
    );
  }

  // Get user bookings
  if (action.type === GET_USER_BOOKINGS) {
    next(apiCallStart({ api: "getUserBookings" }));
    next(
      apiAction({
        url: getUserBookingsUrl(),
        feature: GET_USER_BOOKINGS,
        method: "GET",
      })
    );
  }

  if (action.type === `${GET_USER_BOOKINGS} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "getUserBookings" }));
    // Handle the response data here
    // You can dispatch an action to store the bookings in the state
  }

  if (action.type === `${GET_USER_BOOKINGS} ${API_ERROR}`) {
    next(apiCallComplete({ api: "getUserBookings" }));
    next(
      openSnackbar({ message: "Failed to fetch user bookings", type: "error" })
    );
  }
};

export default user;
